import '../../i18n';

import { IdentityContextProvider } from '@dark-portal/frontend-identity';
import { CProvider } from '@dark-portal/react-components';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ENV } from '@/src/.env';
import { Navigator } from '@/src/features/_infrastructure/navigator/navigator';
import { noop } from '@/src/features/_infrastructure/noop';
import { useRegisterServiceWorker } from '@/src/features/app/behaviours/useRegisterServiceWorker';
import { AppWrapper } from '@/src/features/app/features/wrapper/Wrapper';

export function App() {
  const { i18n } = useTranslation();

  useRegisterServiceWorker();

  return (
    <CProvider locale={i18n.language}>
      <IdentityContextProvider
        config={{
          apiUrl: ENV.API_URL,
          onLogout: () => Navigator.redirectToLogin(),
          onUnauthenticated: () => Navigator.redirectToLogin(),
          onAuthenticated: noop,
        }}
      >
        <AppWrapper />
      </IdentityContextProvider>
    </CProvider>
  );
}
